export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  } 
]
export const OriginType = {
  BASUES: 'baseus',
  OPPO:'oppo'
}
export const _ = undefined
